import 'ionicons';
import '@ionic/core';
import '@ccrpc/webmapgl';
